import React from 'react';
import { Box, Typography } from '@mui/material';

function Hero() {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                backgroundColor: '#f9f9f9', // Subtle background for contrast
                px: 2, // Padding for responsiveness
                py: 8, // Adjusted padding to match smaller text
            }}
        >
            <Typography
                variant="h4" // Smaller size for better consistency
                sx={{
                    fontWeight: 700,
                    fontSize: { xs: '1.75rem', sm: '2rem', md: '2.5rem' },
                    color: '#333',
                    mb: 2,
                }}
            >
                Explore Courses and&nbsp;Labs
            </Typography>
            <Typography
                variant="body2" // Consistent with smaller text across the app
                sx={{
                    fontSize: { xs: '0.875rem', sm: '1rem' },
                    color: '#555',
                    maxWidth: '600px',
                }}
            >
                Discover a wide range of courses designed to elevate your skills in cloud engineering,
                cybersecurity, and more. Start learning today!
            </Typography>
        </Box>
    );
}

export default Hero;
